:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._slotOpenerLine_1ux0k_7 {
  z-index: 100;
  background: #116dff;
  position: absolute;
  border-radius: 50px; }

._slotOpenerLineV3_1ux0k_13 {
  z-index: 100;
  position: absolute;
  display: block;
  transition: width 0.3s ease, left 0.3s ease; }
  ._slotOpenerLineV3_1ux0k_13 path,
  ._slotOpenerLineV3_1ux0k_13 rect {
    transition: 0.3s ease; }
  ._slotOpenerLineV3_1ux0k_13 path {
    stroke: #116dff; }
  ._slotOpenerLineV3_1ux0k_13 path._extraLineLeft_1ux0k_23 {
    stroke-dasharray: 6;
    stroke-dashoffset: -6; }
  ._slotOpenerLineV3_1ux0k_13 path._extraLineRight_1ux0k_26 {
    stroke-dasharray: 6;
    stroke-dashoffset: 6; }
  ._slotOpenerLineV3_1ux0k_13._active_1ux0k_29 rect {
    x: -32px;
    width: 64px; }
  ._slotOpenerLineV3_1ux0k_13._active_1ux0k_29 path._extraLineLeft_1ux0k_23,
  ._slotOpenerLineV3_1ux0k_13._active_1ux0k_29 path._extraLineRight_1ux0k_26 {
    stroke-dashoffset: 0; }
